
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    // Initial check function
    const checkMobile = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    
    // Add event listener for resize events (throttled for performance)
    let resizeTimeout: number
    const handleResize = () => {
      if (resizeTimeout) {
        window.clearTimeout(resizeTimeout)
      }
      resizeTimeout = window.setTimeout(() => {
        checkMobile()
      }, 100)
    }
    
    window.addEventListener("resize", handleResize)
    
    // Also use matchMedia for initial detection and changes in viewport
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const handleMediaQuery = () => {
      setIsMobile(mql.matches)
    }
    
    // Modern browsers use addEventListener for MediaQueryList
    mql.addEventListener("change", handleMediaQuery)
    
    // Set initial value
    checkMobile()
    
    // Log initial detection for debugging
    console.log("Initial mobile detection:", mql.matches ? "mobile" : "desktop")
    
    // Cleanup function to remove listeners
    return () => {
      window.removeEventListener("resize", handleResize)
      mql.removeEventListener("change", handleMediaQuery)
      if (resizeTimeout) {
        window.clearTimeout(resizeTimeout)
      }
    }
  }, [])

  // Return the current state, with a fallback to false
  return isMobile === undefined ? false : isMobile
}
